import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo, UiCol } from "../../../../library/layout/Index";

const RuleHeader = (props) => {
    const { formObject } = props;
    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Main Detail' />
                    </span>
                </UiTitle>

                <UiAction>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColTwo>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="Rule ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "skipIfZero" }} />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Active" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isActive" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ruleTitle" }} value="Rule Title" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "ruleTitle" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ruleDocType" }} value="Target Document" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "ruleDocType" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "startDate" }} value="Date Range From" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "startDate" }} />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "endDate" }} value="To" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "endDate" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceType" }} value="Price Type" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "priceType" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currency" }} />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLblInLine"> <sarasTrans value="Transactions Parameters" /></span>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unit" }} value="Unit" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "unit" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "location" }} value="Location" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "location" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locationGroup" }} value="Location Group" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "locationGroup" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "tagType" }} value="Tag Type Id" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "tagType" }} />
                            </li>
                            <li>
                                <span className="uiLbl"></span>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "tag" }} value="Tag Id" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "tag" }} />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColTwo>
                <div className="uiRow uiSpacer10">
                    <span className="uiLblInLine"><sarasTrans value="Action Parameters" /></span>

                </div>
                <UiGridColTwo>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ruleSeq" }} value="Rule Sequence" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "ruleSeq" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceFormula" }} value="Price Formula" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "priceFormula" }} />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "includesTax" }} value="Includes Tax" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "includesTax" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isVolatile" }} value="Mark Volatile" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isVolatile" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "interaction" }} value="Needs Call" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "interaction" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "skipIfZero" }} value="Skip If Base Price is 0" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "skipIfZero" }} />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColTwo>
            </UiViewContent>
        </UiView>
    )
}

export default withView(RuleHeader, "ruleHeader", "");